import { useState } from "react";
import { Form } from "react-bootstrap";

//kpi-15
const District = ({ data }) => {
  const [selectedYear, setSelectedYear] = useState(2023);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  if (!Array.isArray(data) || data.length === 0 ) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }

  const filteredData = data.filter(
    (item) => Number(item.year) === Number(selectedYear),
  );
  const qsData = filteredData.map((item) => {
    return {
      place: item["District Name"],
      Adult: item["Adult Prevalence"],
      Plhiv: item["PLHIV Size"],
      Hiv: item["New HIV Infections"],
      Population: item["Incidence per 1000 Uninfected Population"],
      Evth: item["Need of Services for EVTH"],
      Priority: item["District Priority"],
    };
  });

  const totalPages = Math.ceil(qsData.length / itemsPerPage);

  // const currentData = qsData.slice(
  //   (currentPage - 1) * itemsPerPage,
  //   currentPage * itemsPerPage
  // );

  // ✅ Paginate excluding the first row
  const currentData = qsData.slice(
    1 + (currentPage - 1) * itemsPerPage,
    1 + currentPage * itemsPerPage,
  );

  const highlightStyle = {
    backgroundColor: "#456882",
    color: "#fff",
    fontWeight: "bold",
  };

  const getPageNumbers = () => {
    const pageNumbers = [];
    const delta = 2;

    const range = [];
    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (currentPage - delta > 2) {
      pageNumbers.push("...");
    }

    pageNumbers.push(...range);

    if (currentPage + delta < totalPages - 1) {
      pageNumbers.push("...");
    }

    return [1, ...pageNumbers, totalPages];
  };

  // inside your District component
  const getPriorityStyle = (priority) => {
    switch (priority) {
      case "Very Low":
        return {
          backgroundColor: "#216e33ff",
          color: "white",
          fontWeight: "bold",
        }; // light green
      case "Low":
        return {
          backgroundColor: "#28a745",
          color: "white",
          fontWeight: "bold",
        }; // yellow
      case "Moderate":
        return {
          backgroundColor: "#ffc107",
          color: "white",
          fontWeight: "bold",
        }; // blue
      case "High":
        return {
          backgroundColor: "#dc3545",
          color: "white",
          fontWeight: "bold",
        }; // red
      default:
        return {};
    }
  };

  return (
    <div style={{ width: "100%", position: "relative" }}>
      <div className="card hptCard mt-4 border-0">
        <div class="card-header brBtomlr">
          <div class="headnumText justify-content-between">
            <h5 style={{ fontWeight: "bold" }}>District Profile</h5>
            <Form.Select
              size="sm"
              style={{ width: "120px" }}
              value={selectedYear}
              onChange={(e) => setSelectedYear(Number(e.target.value))}
            >
              <option value={2023}>2023</option>
              <option value={2025}>2025</option>
            </Form.Select>            
          </div>
        </div>
      </div>
      <div className="card hptCard mt-4 border-0">
        <div className="table-responsive">
          <table className="table  table-bordered">
            <thead className="thead-light">
              <tr>
                <th className="fw-bold">District Name</th>
                <th className="fw-bold text-center">Adult Prevalence</th>
                <th className="fw-bold text-center">PLHIV Size</th>
                <th className="fw-bold text-center">New HIV Infections</th>
                <th className="fw-bold text-center">
                  Incidence per 1,000 Uninfected Population
                </th>
                <th className="fw-bold text-center">
                  Need of Services for EVTH
                </th>
                <th className="fw-bold text-center">District Priority</th>
              </tr>
            </thead>
            {/* <tbody>
              {currentData.map((item, idx) => {
                // 👇 this gives the global index across ALL pages
                const globalIndex = (currentPage - 1) * itemsPerPage + idx;
                console.log("Index:",globalIndex);
                return (
                  <tr
                    key={idx}
                    className={globalIndex === 0 ? "highlight-row" : ""}
                  >
                    <td>{item.place}</td>
                    <td>{item.Adult}</td>
                    <td>{item.Plhiv}</td>
                    <td>{item.Hiv}</td>
                    <td>{item.Population}</td>
                    <td>{item.Evth}</td>
                    <td style={getPriorityStyle(item.Priority)}>
                      {item.Priority}
                    </td>
                  </tr>
                );
              })}
            </tbody> */}
            <tbody>
              {/* Sticky first row (globalIndex 0) */}
              {qsData.length > 0 && (
                <tr key="row-0">
                  <td style={highlightStyle}>{qsData[0].place}</td>
                  <td style={highlightStyle}> {qsData[0].Adult}</td>
                  <td style={highlightStyle}>{qsData[0].Plhiv}</td>
                  <td style={highlightStyle}>{qsData[0].Hiv}</td>
                  <td style={highlightStyle}>{qsData[0].Population}</td>
                  <td style={highlightStyle}>{qsData[0].Evth}</td>
                  <td style={highlightStyle}>{qsData[0].Priority}</td>
                </tr>
              )}

              {/* Paginated rows (excluding first row) */}
              {currentData.map((item, idx) => {
                const globalIndex = (currentPage - 1) * itemsPerPage + idx + 1; // +1 to skip first row

                return (
                  <tr key={item.place}>
                    <td>{item.place}</td>
                    <td>{item.Adult}</td>
                    <td>{item.Plhiv}</td>
                    <td>{item.Hiv}</td>
                    <td>{item.Population}</td>
                    <td>{item.Evth}</td>
                    <td style={getPriorityStyle(item.Priority)}>
                      {item.Priority}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {totalPages > 1 && (
          <div className="card-footer">
            <div className="d-flex justify-content-center mt-3">
              <nav>
                <ul className="pagination">
                  <li
                    className={`page-item ${
                      currentPage === 1 ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    >
                      &laquo;
                    </button>
                  </li>

                  {getPageNumbers().map((page, index) => (
                    <li
                      key={index}
                      className={`page-item ${
                        page === currentPage ? "active" : ""
                      } ${page === "..." ? "disabled" : ""}`}
                    >
                      <button
                        className="page-link"
                        onClick={() =>
                          typeof page === "number" && setCurrentPage(page)
                        }
                        disabled={page === "..."}
                      >
                        {page}
                      </button>
                    </li>
                  ))}

                  <li
                    className={`page-item ${
                      currentPage === totalPages ? "disabled" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                    >
                      &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default District;
